import { faAngleLeft, faAngleRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonVariant } from "../../../core-ui/components/Button/utils";
import { Text } from "../../../core-ui/components/Text/Text";
import {
  TextColor,
  TextStyleVariant,
} from "../../../core-ui/components/Text/TextUtils";
import {
  ProjectPanelTrackButton,
  ProjectPanelTrackButtonContainer,
} from "../ProjectWorkflowPanel.styles";

interface TrackNavigationButtonsProps {
  currentIndex: number;
  totalNumberOfTracks: number;
  handleSelectTrack: (index: number) => void;
  isMobile?: boolean;
}

export const TrackNavigationButtons = (props: TrackNavigationButtonsProps) => {
  const {
    currentIndex,
    totalNumberOfTracks,
    handleSelectTrack,
    isMobile = false,
  } = props;

  return (
    <ProjectPanelTrackButtonContainer>
      <ProjectPanelTrackButton
        disabled={currentIndex === 0}
        onClick={() => handleSelectTrack(currentIndex - 1)}
        variant={ButtonVariant.UNSTYLED}
      >
        <FontAwesomeIcon icon={faAngleLeft} />
        {!isMobile && "Previous"}
      </ProjectPanelTrackButton>
      <Text color={TextColor.SECONDARY} variant={TextStyleVariant.P3}>
        {currentIndex + 1} / {totalNumberOfTracks}
      </Text>
      <ProjectPanelTrackButton
        disabled={currentIndex === totalNumberOfTracks - 1}
        onClick={() => handleSelectTrack(currentIndex + 1)}
        variant={ButtonVariant.UNSTYLED}
      >
        {!isMobile && "Next"}
        <FontAwesomeIcon icon={faAngleRight} />
      </ProjectPanelTrackButton>
    </ProjectPanelTrackButtonContainer>
  );
};
